import ReactPlayer from "react-player"

import "../styles/Home.css"

import Banner from "./navigation/Banner"
import NavBar from "./navigation/NavBar"
import Footer from "./navigation/Footer"

import romaIntro from "../images/roma-intro.mp4"
import homePic from "../images/Welch/Extra/StoreFront.jpg"

function Home() {
  return (
    <div className="home-page-container">
      <Banner />
      <NavBar />

      <div className="home-page-content-container">
        <div className="home-content-1">
          <h1>Home</h1>
        </div>

        <div className="home-content-2">
          <div className="home-video">
            <ReactPlayer
              width="100%"
              height="100%"
              url={romaIntro}
              playing={true}
              controls
            />
          </div>
        </div>

        <div className="home-content-3">
          <div className="home-store-hours-container">
            <div className="home-store-hours-header-container">
              <h3>Store Hours</h3>
            </div>

            <div className="store-hours-content-container">
              <div className="store-hours-content">
                <div className="sh-left">
                  <span>Monday:</span>
                </div>
                <div className="sh-right">
                  <span>9am-6pm</span>
                </div>
              </div>

              <div className="store-hours-content">
                <div className="sh-left">
                  <span>Tuesday:</span>
                </div>
                <div className="sh-right">
                  <span>9am-6pm</span>
                </div>
              </div>

              <div className="store-hours-content">
                <div className="sh-left">
                  <span>Wednesday:</span>
                </div>
                <div className="sh-right">
                  <span>9am-6pm</span>
                </div>
              </div>

              <div className="store-hours-content">
                <div className="sh-left">
                  <span>Thursday:</span>
                </div>
                <div className="sh-right">
                  <span>9am-6pm</span>
                </div>
              </div>              
              
              <div className="store-hours-content">
                <div className="sh-left">
                  <span>Friday:</span>
                </div>
                <div className="sh-right">
                  <span>9am-6pm</span>
                </div>
              </div>              

              <div className="store-hours-content">
                <div className="sh-left">
                  <span>Saturday:</span>
                </div>
                <div className="sh-right">
                  <span>9am-6pm</span>
                </div>
              </div>              

              <div className="store-hours-content">
                <div className="sh-left">
                  <span>Sunday:</span>
                </div>
                <div className="sh-right">
                  <span>9am-5pm</span>
                </div>
              </div>
            </div>
          </div>
          
          <img className="home-pic" src={homePic} alt="Store front" />
        </div>

        <div className="home-content-4">
          <div className="map-container">
            <iframe 
              title="Roma-map" 
              width="100%" 
              height="100%" 
              loading="lazy" 
              src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJsYrI6QpF5IkRyGjNqnJGkAo&key=AIzaSyDoStL059QVI7A4_yft88HJlEPI8fgRHkg">
            </iframe>
          </div>
        </div>

        <Footer />

      </div>
    </div>
  )
}

export default Home
